// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import { Popover } from "bootstrap"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

// Bootstrap
// this is in node_modules import "../../assets/javascripts/bootstrap"
import "../stylesheets/application"

// console.log('Hello from app/javascript/packs/application.js')

// Initialize BS popovers
document.addEventListener("turbolinks:load", function (event) {
  const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
  const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))
})

// Focus on search box for filtering with fewer mouse clicks
document.addEventListener("turbolinks:load", function (event) {
    // IPAM page requires brief delay
    setTimeout(function(){
      const inputBoxes = document.querySelectorAll('div.dataTables_filter input');
      // only focus iff page has exactly one search box
      if (inputBoxes.length == 1) {
        inputBoxes[0].focus();
      }
    },1);
});
